module.exports = __webpack_public_path__ + "img/2f53846efeacc1ec0255dfa2bc5b2446.cf886374.png";